<template>
  <div class="permissions-modal">
    <div class="confirm-modal-title">
      {{
        isSuccess
          ? $t("users.form.permissionChanged")
          : $t("common.permissions")
      }}
    </div>
    <div class="confirm-modal-body">
      <template v-if="!isSuccess">
        {{ $t("common.notes.areYouSureYouWant") }}
        <b>"{{ $t("common.change") }}"</b>
        {{ $t("users.form.usersPermissions") }}
      </template>

      <template v-else>
        <span v-html="$t('users.form.permissionsChangedSuccess')"></span>
      </template>
    </div>

    <template v-if="!isSuccess">
      <div class="d-flex justify-content-center" style="margin-bottom: 14px">
        <vp-treeselect
          v-model="selectedRole"
          :label="$t('common.userRole')"
          :showPlaceholderIcon="true"
          :options="user_roles_list"
          :isMultiple="false"
          :flat="false"
          :width="'416'"
        />
      </div>
      <h6 v-if="selectedRole" class="datepicker-hintone">
        <span
          ><b>{{ $t("common.notes.note") }}:</b>
          {{ $t("common.notes.rolesHint") }}</span
        >
      </h6>

      <div class="d-flex justify-content-center" style="margin-bottom: 14px">
        <vp-treeselect
          v-model="siteIds"
          :label="$t('common.site')"
          :showPlaceholderIcon="true"
          :options="sitesOptions"
          :isLoading="sitesLoading"
          :width="'416'"
        />
      </div>

      <div class="d-flex justify-content-center">
        <vp-treeselect
          v-model="userTypeIds"
          :label="$t('common.userType')"
          :showPlaceholderIcon="true"
          :options="userTypesOptions"
          :isLoading="userTypesLoading"
          :width="'416'"
        />
      </div>
    </template>

    <hr class="confirm-modal-divider" />
    <div :class="isSuccess ? 'okay-btn' : 'change-btn'">
      <button
        @click="!isSuccess ? onSubmit() : closeModal()"
        class="confirm-modal-btn"
        :disabled="
          (!isSuccess &&
            (!selectedRole ||
              userTypeIds.length == 0 ||
              siteIds.length == 0)) ||
          isLoading
        "
      >
        <i
          v-if="isLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ isSuccess ? $t("common.okay") : $t("common.change") }}
      </button>
      <button
        v-if="!isSuccess"
        @click="$bvModal.hide('permissions')"
        class="cancel-modal-btn"
      >
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    selectedUsers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      user_roles_list: [],
      selectedRole: null,
      userTypeIds: [],
      siteIds: [],
      sitesLoading: true,
      userTypesLoading: true,
      isSuccess: false,
      isLoading: false,
      sitesOptions: [],
      userTypesOptions: [],
    };
  },
  computed: {
    // ...mapGetters("userType", ["getAllUsersTypes"]),
    // ...mapGetters("sites", ["getSites"]),
    ...mapGetters("authfack", ["userDetails"]),
  },
  methods: {
    ...mapActions("users", [
      "updateUserResource",
      "fetchUserRoles",
      "fetchSitesAndUserTypesWithPermissions",
    ]),
    // ...mapActions("sites", ["fetchSites"]),
    // ...mapActions("userType", ["fetchAllUserType", "fetchAllParentsUserType"]),
    async onSubmit() {
      console.log("isSuccess", this.selectedUsers);
      this.isLoading = true;
      const data = this.selectedUsers.map((user) => {
        return {
          entityUserId: user.Data.current_entity.id,
          userId: user.Data.current_entity.user_id,
          roleId: this.selectedRole,
          siteIds: this.siteIds,
          userTypeIds: this.userTypeIds,
          type: "mass",
        };
      });
      this.updateUserResource(data).then(() => {
        this.isSuccess = true;
        this.isLoading = false;
      });
      //   this.$bvModal.show("revoke-confirm-modal");
    },
    closeModal() {
      this.$emit("resourceUpdated", "resourceUpdated");
    },
  },
  async beforeMount() {
    // this.fetchAllParentsUserType().then((data) => {
    //   this.userTypesOptions = data.data;
    //   this.userTypesLoading = false;
    // });
    // this.fetchSites().then(() => {
    //   this.sitesLoading = false;
    // });

    await this.fetchUserRoles().then((data) => {
      this.user_roles_list = [];
      for (let i = 0; i < data.data.length; i++) {
        this.user_roles_list.push({
          id: data.data[i].id,
          label: data.data[i].name,
        });
      }
    });

    await this.fetchSitesAndUserTypesWithPermissions({
      entityUserId: this.userDetails.id,
    }).then((data) => {
      // console.log('data', data);
      this.sitesOptions = data.sites;
      this.userTypesOptions = data.userTypes;
      this.sitesLoading = false;
      this.userTypesLoading = false;
    });
  },
};
</script>

<style lang="scss">
div#permissions___BV_modal_content_ {
  width: 579px !important;
  border-radius: 26px !important;
  margin-top: 80px !important;
  margin-bottom: 50px !important;
  .permissions-modal {
    button.confirm-modal-btn:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
    button.confirm-modal-btn {
      margin-inline-end: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .okay-btn {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .confirm-modal-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: start;
    }
    .confirm-modal-body {
      color: #787878;

      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: center;
      // width: 414px;
      margin: 40px auto 14px auto;
    }
    .confirm-modal-btn {
      background-color: #103f5e;
      color: #ffffff;

      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      border: 0;
      border-radius: 24px;
      width: 112px;
      height: 33px;
      // margin-top: 20px;
      // margin-inline-start: 145px;
    }
    .confirm-modal-divider {
      // margin: 0;
      width: 488px;
      margin-top: 40px;
      margin-bottom: 20px;
    }
    .change-btn {
      display: flex;
      align-items: baseline;
      justify-content: center;
    }
    .cancel-modal-btn {
      background-color: #ffffff;
      color: #f46a6a;
      border: 1px solid #f46a6a !important;
      width: 112px;
      height: 33px;
      font-size: 16px;
      margin-inline-start: 15px;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      border: 0;
      border-radius: 24px;
    }
    .w-60 {
      width: 60%;
    }

    h6.datepicker-hintone {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      margin-bottom: 14px !important;
      color: #939393;
      // margin-top: 18px;
      line-height: 24px;
      // opacity: 0.8;
      width: 365px;
      margin-top: -7px;
      margin-inline-start: 46px;
    }
  }
}
</style>
